import { render, staticRenderFns } from "./Roadmap.vue?vue&type=template&id=58c1700a&scoped=true&"
var script = {}
import style0 from "./Roadmap.vue?vue&type=style&index=0&id=58c1700a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1700a",
  null
  
)

export default component.exports